
export const flightsSampleData = [
  {
    'id': 'a9869d6b327d4d6897244a92387e931c',
    'scheduled': '2021-09-23 18:25:00',
    'estimated': '2021-09-23 18:25:00',
    'claim': null,
    'checkIn': null,
    'status': 'InAir',
    'flightType': 'ARRIVAL',
    'overrides': {
      'estimated': null,
      'gate': null,
      'claim': null,
      'checkIn': null,
      'status': null,
      'languages': null,
      'remarks': null
    },
    'codeshares': [],
    'flightNumber': '154',
    'airlineCode': 'BW',
    'airlineCodeType': 'IATA',
    'airline': 'CARIBBEAN AIRLINES LIMITED',
    'state': 'BB',
    'city': 'BRIDGETOWN',
    'cityCode': 'BGI',
    'gate': null
  },
  {
    'id': '41a7c41d3cee440e9f915893c29a2bf1',
    'scheduled': '2021-09-23 18:29:00',
    'estimated': '2021-09-23 18:29:00',
    'claim': null,
    'checkIn': null,
    'status': 'InAir',
    'flightType': 'ARRIVAL',
    'overrides': {
      'estimated': null,
      'gate': null,
      'claim': null,
      'checkIn': null,
      'status': null,
      'languages': null,
      'remarks': null
    },
    'codeshares': [
      {
        'airlineCode': 'QR',
        'airlineCodeType': 'Iata',
        'airline': 'Qatar Airways',
        'flightNumber': '2153'
      }
    ],
    'flightNumber': '545',
    'airlineCode': 'AS',
    'airlineCodeType': 'IATA',
    'airline': 'ALASKA AIRLINES',
    'state': 'OR',
    'city': 'PORTLAND',
    'cityCode': 'PDX',
    'gate': 'C15'
  },
  {
    'id': 'c2de17a8b87849dd8ad741479522e510',
    'scheduled': '2021-09-23 18:30:00',
    'estimated': '2021-09-23 18:30:00',
    'claim': '2',
    'checkIn': null,
    'status': 'InAir',
    'flightType': 'ARRIVAL',
    'overrides': {
      'estimated': null,
      'gate': null,
      'claim': null,
      'checkIn': null,
      'status': null,
      'languages': null,
      'remarks': null
    },
    'codeshares': [
      {
        'airlineCode': 'AA',
        'airlineCodeType': 'Iata',
        'airline': 'American Airlines',
        'flightNumber': '9152'
      },
      {
        'airlineCode': 'EK',
        'airlineCodeType': 'Iata',
        'airline': 'Emirates Airline',
        'flightNumber': '6758'
      },
      {
        'airlineCode': 'EY',
        'airlineCodeType': 'Iata',
        'airline': 'Etihad Airways',
        'flightNumber': '8279'
      },
      {
        'airlineCode': 'FI',
        'airlineCodeType': 'Iata',
        'airline': 'Icelandair',
        'flightNumber': '7922'
      },
      {
        'airlineCode': 'QR',
        'airlineCodeType': 'Iata',
        'airline': 'Qatar Airways',
        'flightNumber': '3908'
      }
    ],
    'flightNumber': '710',
    'airlineCode': 'B6',
    'airlineCodeType': 'IATA',
    'airline': 'JETBLUE AIRWAYS',
    'state': 'TX',
    'city': 'DALLAS-FORT WORTH',
    'cityCode': 'DFW',
    'gate': 'E10'
  },
  {
    'id': '471f8305e55640aab31c864a8988baf7',
    'scheduled': '2021-09-23 18:31:00',
    'estimated': '2021-09-23 18:31:00',
    'claim': '2',
    'checkIn': null,
    'status': 'Delayed',
    'flightType': 'ARRIVAL',
    'overrides': {
      'estimated': null,
      'gate': null,
      'claim': null,
      'checkIn': null,
      'status': null,
      'languages': null,
      'remarks': null
    },
    'codeshares': [
      {
        'airlineCode': 'AA',
        'airlineCodeType': 'Iata',
        'airline': 'American Airlines',
        'flightNumber': '9173'
      },
      {
        'airlineCode': 'EY',
        'airlineCodeType': 'Iata',
        'airline': 'Etihad Airways',
        'flightNumber': '8273'
      },
      {
        'airlineCode': 'HA',
        'airlineCodeType': 'Iata',
        'airline': 'Hawaiian Airlines',
        'flightNumber': '2049'
      },
      {
        'airlineCode': 'LY',
        'airlineCodeType': 'Iata',
        'airline': 'El Al Israel Airlines',
        'flightNumber': '8693'
      },
      {
        'airlineCode': 'QR',
        'airlineCodeType': 'Iata',
        'airline': 'Qatar Airways',
        'flightNumber': '3902'
      },
      {
        'airlineCode': 'SQ',
        'airlineCodeType': 'Iata',
        'airline': 'Singapore Airlines',
        'flightNumber': '1490'
      },
      {
        'airlineCode': 'TK',
        'airlineCodeType': 'Iata',
        'airline': 'Turkish Airlines',
        'flightNumber': '8990'
      }
    ],
    'flightNumber': '854',
    'airlineCode': 'B6',
    'airlineCodeType': 'IATA',
    'airline': 'JETBLUE AIRWAYS',
    'state': 'FL',
    'city': 'WEST PALM BEACH',
    'cityCode': 'PBI',
    'gate': 'C14'
  },
  {
    'id': '14e5c9ff1d444a15b8b9f1049103d635',
    'scheduled': '2021-09-23 18:31:00',
    'estimated': '2021-09-23 18:31:00',
    'claim': null,
    'checkIn': null,
    'status': 'Delayed',
    'flightType': 'ARRIVAL',
    'overrides': {
      'estimated': null,
      'gate': null,
      'claim': null,
      'checkIn': null,
      'status': null,
      'languages': null,
      'remarks': null
    },
    'codeshares': [
      {
        'airlineCode': 'AZ',
        'airlineCodeType': 'Iata',
        'airline': 'Alitalia',
        'flightNumber': '3139'
      },
      {
        'airlineCode': 'CI',
        'airlineCodeType': 'Iata',
        'airline': 'China Airlines',
        'flightNumber': '9089'
      },
      {
        'airlineCode': 'KL',
        'airlineCodeType': 'Iata',
        'airline': 'KLM Royal Dutch Airlines',
        'flightNumber': '6717'
      },
      {
        'airlineCode': 'VS',
        'airlineCodeType': 'Iata',
        'airline': 'Virgin Atlantic',
        'flightNumber': '1895'
      },
      {
        'airlineCode': 'WS',
        'airlineCodeType': 'Iata',
        'airline': 'WestJet Airlines',
        'flightNumber': '6371'
      }
    ],
    'flightNumber': '5018',
    'airlineCode': 'DL',
    'airlineCodeType': 'IATA',
    'airline': 'DELTA AIR LINES',
    'state': 'OH',
    'city': 'CLEVELAND',
    'cityCode': 'CLE',
    'gate': 'B04'
  },
  {
    'id': '80119c8c5d5b42adad6014e9193d3af7',
    'scheduled': '2021-09-23 18:32:00',
    'estimated': '2021-09-23 18:32:00',
    'claim': null,
    'checkIn': null,
    'status': 'Delayed',
    'flightType': 'ARRIVAL',
    'overrides': {
      'estimated': null,
      'gate': null,
      'claim': null,
      'checkIn': null,
      'status': null,
      'languages': null,
      'remarks': null
    },
    'codeshares': [
      {
        'airlineCode': 'AF',
        'airlineCodeType': 'Iata',
        'airline': 'Air France',
        'flightNumber': '2570'
      },
      {
        'airlineCode': 'AZ',
        'airlineCodeType': 'Iata',
        'airline': 'Alitalia',
        'flightNumber': '3227'
      },
      {
        'airlineCode': 'KL',
        'airlineCodeType': 'Iata',
        'airline': 'KLM Royal Dutch Airlines',
        'flightNumber': '5611'
      },
      {
        'airlineCode': 'VS',
        'airlineCodeType': 'Iata',
        'airline': 'Virgin Atlantic',
        'flightNumber': '4630'
      },
      {
        'airlineCode': 'WS',
        'airlineCodeType': 'Iata',
        'airline': 'WestJet Airlines',
        'flightNumber': '6626'
      }
    ],
    'flightNumber': '5776',
    'airlineCode': 'DL',
    'airlineCodeType': 'IATA',
    'airline': 'DELTA AIR LINES',
    'state': 'DC',
    'city': 'WASHINGTON',
    'cityCode': 'DCA',
    'gate': '19'
  },
  {
    'id': 'e69d3fe74e8546fbab7047c07f01084c',
    'scheduled': '2021-09-23 18:34:00',
    'estimated': '2021-09-23 18:34:00',
    'claim': null,
    'checkIn': null,
    'status': 'InAir',
    'flightType': 'ARRIVAL',
    'overrides': {
      'estimated': null,
      'gate': null,
      'claim': null,
      'checkIn': null,
      'status': null,
      'languages': null,
      'remarks': null
    },
    'codeshares': [
      {
        'airlineCode': 'KL',
        'airlineCodeType': 'Iata',
        'airline': 'KLM Royal Dutch Airlines',
        'flightNumber': '5537'
      },
      {
        'airlineCode': 'AF',
        'airlineCodeType': 'Iata',
        'airline': 'Air France',
        'flightNumber': '2145'
      },
      {
        'airlineCode': 'AZ',
        'airlineCodeType': 'Iata',
        'airline': 'Alitalia',
        'flightNumber': '3400'
      },
      {
        'airlineCode': 'UX',
        'airlineCodeType': 'Iata',
        'airline': 'Air Europa',
        'flightNumber': '3404'
      },
      {
        'airlineCode': 'VS',
        'airlineCodeType': 'Iata',
        'airline': 'Virgin Atlantic',
        'flightNumber': '4800'
      }
    ],
    'flightNumber': '795',
    'airlineCode': 'DL',
    'airlineCodeType': 'IATA',
    'airline': 'DELTA AIR LINES',
    'state': 'AZ',
    'city': 'PHOENIX',
    'cityCode': 'PHX',
    'gate': 'F11'
  },
  {
    'id': '739edcf6b2d24d8c8811468a2bfe7e56',
    'scheduled': '2021-09-23 18:36:00',
    'estimated': '2021-09-23 18:36:00',
    'claim': '7',
    'checkIn': null,
    'status': 'InAir',
    'flightType': 'ARRIVAL',
    'overrides': {
      'estimated': null,
      'gate': null,
      'claim': null,
      'checkIn': null,
      'status': null,
      'languages': null,
      'remarks': null
    },
    'codeshares': [
      {
        'airlineCode': 'AT',
        'airlineCodeType': 'Iata',
        'airline': 'Royal Air Maroc',
        'flightNumber': '5010'
      },
      {
        'airlineCode': 'B6',
        'airlineCodeType': 'Iata',
        'airline': 'JetBlue Airways',
        'flightNumber': '4043'
      },
      {
        'airlineCode': 'BA',
        'airlineCodeType': 'Iata',
        'airline': 'British Airways',
        'flightNumber': '4327'
      },
      {
        'airlineCode': 'IB',
        'airlineCodeType': 'Iata',
        'airline': 'Iberia Airlines',
        'flightNumber': '4606'
      },
      {
        'airlineCode': 'QF',
        'airlineCodeType': 'Iata',
        'airline': 'Qantas Airways',
        'flightNumber': '3107'
      },
      {
        'airlineCode': 'QR',
        'airlineCodeType': 'Iata',
        'airline': 'Qatar Airways',
        'flightNumber': '7686'
      },
      {
        'airlineCode': 'RJ',
        'airlineCodeType': 'Iata',
        'airline': 'Royal Jordanian',
        'flightNumber': '7019'
      }
    ],
    'flightNumber': '238',
    'airlineCode': 'AA',
    'airlineCodeType': 'IATA',
    'airline': 'AMERICAN AIRLINES',
    'state': 'CA',
    'city': 'LOS ANGELES',
    'cityCode': 'LAX',
    'gate': '47B'
  },
  {
    'id': 'f830c0423df8426fb53d2a471ad06b10',
    'scheduled': '2021-09-23 18:39:00',
    'estimated': '2021-09-23 18:39:00',
    'claim': null,
    'checkIn': null,
    'status': 'Delayed',
    'flightType': 'ARRIVAL',
    'overrides': {
      'estimated': null,
      'gate': null,
      'claim': null,
      'checkIn': null,
      'status': null,
      'languages': null,
      'remarks': null
    },
    'codeshares': [
      {
        'airlineCode': 'AZ',
        'airlineCodeType': 'Iata',
        'airline': 'Alitalia',
        'flightNumber': '3451'
      },
      {
        'airlineCode': 'KE',
        'airlineCodeType': 'Iata',
        'airline': 'Korean Air',
        'flightNumber': '3938'
      },
      {
        'airlineCode': 'KL',
        'airlineCodeType': 'Iata',
        'airline': 'KLM Royal Dutch Airlines',
        'flightNumber': '5423'
      },
      {
        'airlineCode': 'VS',
        'airlineCodeType': 'Iata',
        'airline': 'Virgin Atlantic',
        'flightNumber': '3094'
      },
      {
        'airlineCode': 'WS',
        'airlineCodeType': 'Iata',
        'airline': 'WestJet Airlines',
        'flightNumber': '6483'
      }
    ],
    'flightNumber': '5632',
    'airlineCode': 'DL',
    'airlineCodeType': 'IATA',
    'airline': 'DELTA AIR LINES',
    'state': 'MA',
    'city': 'BOSTON',
    'cityCode': 'BOS',
    'gate': 'A6'
  },
  {
    'id': 'bf61bb18254a4895884762906149f10e',
    'scheduled': '2021-09-23 18:40:00',
    'estimated': '2021-09-23 18:40:00',
    'claim': null,
    'checkIn': null,
    'status': 'InGate',
    'flightType': 'ARRIVAL',
    'overrides': {
      'estimated': null,
      'gate': null,
      'claim': null,
      'checkIn': null,
      'status': null,
      'languages': null,
      'remarks': null
    },
    'codeshares': [
      {
        'airlineCode': 'AF',
        'airlineCodeType': 'Iata',
        'airline': 'Air France',
        'flightNumber': '9740'
      },
      {
        'airlineCode': 'DL',
        'airlineCodeType': 'Iata',
        'airline': 'Delta Air Lines',
        'flightNumber': '6699'
      },
      {
        'airlineCode': 'EY',
        'airlineCodeType': 'Iata',
        'airline': 'Etihad Airways',
        'flightNumber': '3072'
      },
      {
        'airlineCode': 'KQ',
        'airlineCodeType': 'Iata',
        'airline': 'Kenya Airways',
        'flightNumber': '3916'
      }
    ],
    'flightNumber': '610',
    'airlineCode': 'AZ',
    'airlineCodeType': 'IATA',
    'airline': 'ALITALIA',
    'state': 'IT',
    'city': 'ROME',
    'cityCode': 'FCO',
    'gate': null
  },
  {
    'id': 'b888d5aba8904927a236bba6f6fe9564',
    'scheduled': '2021-09-23 18:42:00',
    'estimated': '2021-09-23 18:42:00',
    'claim': null,
    'checkIn': null,
    'status': 'InAir',
    'flightType': 'ARRIVAL',
    'overrides': {
      'estimated': null,
      'gate': null,
      'claim': null,
      'checkIn': null,
      'status': null,
      'languages': null,
      'remarks': null
    },
    'codeshares': [],
    'flightNumber': '612',
    'airlineCode': 'DL',
    'airlineCodeType': 'IATA',
    'airline': 'DELTA AIR LINES',
    'state': 'AW',
    'city': 'ARUBA',
    'cityCode': 'AUA',
    'gate': 'G7'
  },
  {
    'id': '3d04f51363e5413991893f1409f65bc0',
    'scheduled': '2021-09-23 18:44:00',
    'estimated': '2021-09-23 18:44:00',
    'claim': null,
    'checkIn': null,
    'status': 'Delayed',
    'flightType': 'ARRIVAL',
    'overrides': {
      'estimated': null,
      'gate': null,
      'claim': null,
      'checkIn': null,
      'status': null,
      'languages': null,
      'remarks': null
    },
    'codeshares': [
      {
        'airlineCode': 'AF',
        'airlineCodeType': 'Iata',
        'airline': 'Air France',
        'flightNumber': '2165'
      },
      {
        'airlineCode': 'KL',
        'airlineCodeType': 'Iata',
        'airline': 'KLM Royal Dutch Airlines',
        'flightNumber': '5569'
      },
      {
        'airlineCode': 'VS',
        'airlineCodeType': 'Iata',
        'airline': 'Virgin Atlantic',
        'flightNumber': '2892'
      },
      {
        'airlineCode': 'WS',
        'airlineCodeType': 'Iata',
        'airline': 'WestJet Airlines',
        'flightNumber': '6588'
      }
    ],
    'flightNumber': '5660',
    'airlineCode': 'DL',
    'airlineCodeType': 'IATA',
    'airline': 'DELTA AIR LINES',
    'state': 'NC',
    'city': 'CHARLOTTE',
    'cityCode': 'CLT',
    'gate': 'A1'
  },
  {
    'id': '5ff875ba6c5940f5a89b46273c4045e2',
    'scheduled': '2021-09-23 18:44:00',
    'estimated': '2021-09-23 18:44:00',
    'claim': null,
    'checkIn': null,
    'status': 'Delayed',
    'flightType': 'ARRIVAL',
    'overrides': {
      'estimated': null,
      'gate': null,
      'claim': null,
      'checkIn': null,
      'status': null,
      'languages': null,
      'remarks': null
    },
    'codeshares': [
      {
        'airlineCode': 'AF',
        'airlineCodeType': 'Iata',
        'airline': 'Air France',
        'flightNumber': '2615'
      },
      {
        'airlineCode': 'AZ',
        'airlineCodeType': 'Iata',
        'airline': 'Alitalia',
        'flightNumber': '3087'
      },
      {
        'airlineCode': 'CI',
        'airlineCodeType': 'Iata',
        'airline': 'China Airlines',
        'flightNumber': '9176'
      },
      {
        'airlineCode': 'KL',
        'airlineCodeType': 'Iata',
        'airline': 'KLM Royal Dutch Airlines',
        'flightNumber': '8111'
      },
      {
        'airlineCode': 'VS',
        'airlineCodeType': 'Iata',
        'airline': 'Virgin Atlantic',
        'flightNumber': '4646'
      },
      {
        'airlineCode': 'WS',
        'airlineCodeType': 'Iata',
        'airline': 'WestJet Airlines',
        'flightNumber': '7230'
      }
    ],
    'flightNumber': '5704',
    'airlineCode': 'DL',
    'airlineCodeType': 'IATA',
    'airline': 'DELTA AIR LINES',
    'state': 'PA',
    'city': 'PITTSBURGH',
    'cityCode': 'PIT',
    'gate': 'D78'
  },
  {
    'id': 'd123683d38164a4abbadec308becfc8f',
    'scheduled': '2021-09-23 17:14:00',
    'estimated': '2021-09-23 17:14:00',
    'claim': null,
    'checkIn': null,
    'status': 'InGate',
    'flightType': 'ARRIVAL',
    'overrides': {
      'estimated': null,
      'gate': null,
      'claim': null,
      'checkIn': null,
      'status': null,
      'languages': null,
      'remarks': null
    },
    'codeshares': [
      {
        'airlineCode': 'AF',
        'airlineCodeType': 'Iata',
        'airline': 'Air France',
        'flightNumber': '5937'
      },
      {
        'airlineCode': 'AM',
        'airlineCodeType': 'Iata',
        'airline': 'AeroMexico',
        'flightNumber': '3353'
      },
      {
        'airlineCode': 'AZ',
        'airlineCodeType': 'Iata',
        'airline': 'Alitalia',
        'flightNumber': '3390'
      },
      {
        'airlineCode': 'KL',
        'airlineCodeType': 'Iata',
        'airline': 'KLM Royal Dutch Airlines',
        'flightNumber': '5731'
      },
      {
        'airlineCode': 'VS',
        'airlineCodeType': 'Iata',
        'airline': 'Virgin Atlantic',
        'flightNumber': '4822'
      }
    ],
    'flightNumber': '684',
    'airlineCode': 'DL',
    'airlineCodeType': 'IATA',
    'airline': 'DELTA AIR LINES',
    'state': 'TX',
    'city': 'AUSTIN',
    'cityCode': 'AUS',
    'gate': '8'
  },
  {
    'id': '3093DAFD75ED41298FD6A1AB261A380B',
    'scheduled': '2021-09-23 17:14:00',
    'estimated': '2021-09-23 17:14:00',
    'claim': null,
    'checkIn': null,
    'status': 'Delayed',
    'flightType': 'ARRIVAL',
    'overrides': {
      'estimated': null,
      'gate': null,
      'claim': null,
      'checkIn': null,
      'status': null,
      'languages': null,
      'remarks': null
    },
    'codeshares': [
      {
        'airlineCode': 'AM',
        'airlineCodeType': 'Iata',
        'airline': 'AeroMexico',
        'flightNumber': '3353'
      },
      {
        'airlineCode': 'AF',
        'airlineCodeType': 'Iata',
        'airline': 'Air France',
        'flightNumber': '5937'
      },
      {
        'airlineCode': 'AZ',
        'airlineCodeType': 'Iata',
        'airline': 'Alitalia',
        'flightNumber': '3390'
      },
      {
        'airlineCode': 'KL',
        'airlineCodeType': 'Iata',
        'airline': 'KLM Royal Dutch Airlines',
        'flightNumber': '5731'
      },
      {
        'airlineCode': 'VS',
        'airlineCodeType': 'Iata',
        'airline': 'Virgin Atlantic',
        'flightNumber': '4822'
      }
    ],
    'flightNumber': '684',
    'airlineCode': 'DL',
    'airlineCodeType': 'IATA',
    'airline': 'DELTA AIR LINES',
    'state': 'TX',
    'city': 'AUSTIN',
    'cityCode': 'AUS',
    'gate': 'A25'
  },
  {
    'id': '1cb318a7e46142d1b5d771eb72986cfb',
    'scheduled': '2021-09-23 18:45:00',
    'estimated': '2021-09-23 18:45:00',
    'claim': '8',
    'checkIn': null,
    'status': 'InAir',
    'flightType': 'ARRIVAL',
    'overrides': {
      'estimated': null,
      'gate': null,
      'claim': null,
      'checkIn': null,
      'status': null,
      'languages': null,
      'remarks': null
    },
    'codeshares': [],
    'flightNumber': '1568',
    'airlineCode': 'B6',
    'airlineCodeType': 'IATA',
    'airline': 'JETBLUE AIRWAYS',
    'state': 'DO',
    'city': 'PUNTA CANA',
    'cityCode': 'PUJ',
    'gate': '15'
  },
  {
    'id': '1d379081409c4f7585496d7de0c4ef18',
    'scheduled': '2021-09-23 18:45:00',
    'estimated': '2021-09-23 18:45:00',
    'claim': null,
    'checkIn': null,
    'status': 'Delayed',
    'flightType': 'ARRIVAL',
    'overrides': {
      'estimated': null,
      'gate': null,
      'claim': null,
      'checkIn': null,
      'status': null,
      'languages': null,
      'remarks': null
    },
    'codeshares': [
      {
        'airlineCode': 'KL',
        'airlineCodeType': 'Iata',
        'airline': 'KLM Royal Dutch Airlines',
        'flightNumber': '5875'
      }
    ],
    'flightNumber': '4939',
    'airlineCode': 'DL',
    'airlineCodeType': 'IATA',
    'airline': 'DELTA AIR LINES',
    'state': 'ME',
    'city': 'BANGOR',
    'cityCode': 'BGR',
    'gate': '6'
  },
  {
    'id': '2c4fbb7014664ff4b2e1a9ba3ebf4ae8',
    'scheduled': '2021-09-23 18:45:00',
    'estimated': '2021-09-23 18:45:00',
    'claim': null,
    'checkIn': null,
    'status': 'Delayed',
    'flightType': 'ARRIVAL',
    'overrides': {
      'estimated': null,
      'gate': null,
      'claim': null,
      'checkIn': null,
      'status': null,
      'languages': null,
      'remarks': null
    },
    'codeshares': [
      {
        'airlineCode': 'AF',
        'airlineCodeType': 'Iata',
        'airline': 'Air France',
        'flightNumber': '5901'
      },
      {
        'airlineCode': 'AZ',
        'airlineCodeType': 'Iata',
        'airline': 'Alitalia',
        'flightNumber': '3418'
      },
      {
        'airlineCode': 'CI',
        'airlineCodeType': 'Iata',
        'airline': 'China Airlines',
        'flightNumber': '9178'
      },
      {
        'airlineCode': 'KL',
        'airlineCodeType': 'Iata',
        'airline': 'KLM Royal Dutch Airlines',
        'flightNumber': '6869'
      },
      {
        'airlineCode': 'VS',
        'airlineCodeType': 'Iata',
        'airline': 'Virgin Atlantic',
        'flightNumber': '4734'
      },
      {
        'airlineCode': 'WS',
        'airlineCodeType': 'Iata',
        'airline': 'WestJet Airlines',
        'flightNumber': '7255'
      }
    ],
    'flightNumber': '4631',
    'airlineCode': 'DL',
    'airlineCodeType': 'IATA',
    'airline': 'DELTA AIR LINES',
    'state': 'VA',
    'city': 'RICHMOND',
    'cityCode': 'RIC',
    'gate': 'B6'
  },
  {
    'id': '1903921f50cc44638a105ff1082e5a20',
    'scheduled': '2021-09-23 18:45:00',
    'estimated': '2021-09-23 18:45:00',
    'claim': null,
    'checkIn': null,
    'status': 'Delayed',
    'flightType': 'ARRIVAL',
    'overrides': {
      'estimated': null,
      'gate': null,
      'claim': null,
      'checkIn': null,
      'status': null,
      'languages': null,
      'remarks': null
    },
    'codeshares': [
      {
        'airlineCode': 'KL',
        'airlineCodeType': 'Iata',
        'airline': 'KLM Royal Dutch Airlines',
        'flightNumber': '6615'
      },
      {
        'airlineCode': 'AF',
        'airlineCodeType': 'Iata',
        'airline': 'Air France',
        'flightNumber': '3714'
      },
      {
        'airlineCode': 'AZ',
        'airlineCodeType': 'Iata',
        'airline': 'Alitalia',
        'flightNumber': '2760'
      },
      {
        'airlineCode': 'CI',
        'airlineCodeType': 'Iata',
        'airline': 'China Airlines',
        'flightNumber': '9095'
      },
      {
        'airlineCode': 'VS',
        'airlineCodeType': 'Iata',
        'airline': 'Virgin Atlantic',
        'flightNumber': '4690'
      },
      {
        'airlineCode': 'WS',
        'airlineCodeType': 'Iata',
        'airline': 'WestJet Airlines',
        'flightNumber': '6807'
      }
    ],
    'flightNumber': '5451',
    'airlineCode': 'DL',
    'airlineCodeType': 'IATA',
    'airline': 'DELTA AIR LINES',
    'state': 'DC',
    'city': 'WASHINGTON',
    'cityCode': 'IAD',
    'gate': 'B72'
  },
  {
    'id': '861a0f6881284b9dae313763f77ff5a1',
    'scheduled': '2021-09-23 18:53:00',
    'estimated': '2021-09-23 18:53:00',
    'claim': '3',
    'checkIn': null,
    'status': 'InAir',
    'flightType': 'ARRIVAL',
    'overrides': {
      'estimated': null,
      'gate': null,
      'claim': null,
      'checkIn': null,
      'status': null,
      'languages': null,
      'remarks': null
    },
    'codeshares': [
      {
        'airlineCode': 'AA',
        'airlineCodeType': 'Iata',
        'airline': 'American Airlines',
        'flightNumber': '9281'
      },
      {
        'airlineCode': 'EK',
        'airlineCodeType': 'Iata',
        'airline': 'Emirates Airline',
        'flightNumber': '6170'
      },
      {
        'airlineCode': 'EY',
        'airlineCodeType': 'Iata',
        'airline': 'Etihad Airways',
        'flightNumber': '8351'
      },
      {
        'airlineCode': 'LY',
        'airlineCodeType': 'Iata',
        'airline': 'El Al Israel Airlines',
        'flightNumber': '8742'
      },
      {
        'airlineCode': 'QR',
        'airlineCodeType': 'Iata',
        'airline': 'Qatar Airways',
        'flightNumber': '4166'
      },
      {
        'airlineCode': 'SQ',
        'airlineCodeType': 'Iata',
        'airline': 'Singapore Airlines',
        'flightNumber': '1522'
      },
      {
        'airlineCode': 'TK',
        'airlineCodeType': 'Iata',
        'airline': 'Turkish Airlines',
        'flightNumber': '8540'
      }
    ],
    'flightNumber': '872',
    'airlineCode': 'B6',
    'airlineCodeType': 'IATA',
    'airline': 'JETBLUE AIRWAYS',
    'state': 'UT',
    'city': 'SALT LAKE CITY',
    'cityCode': 'SLC',
    'gate': 'B9'
  },
  {
    'id': 'efd580ef63274c6badc02a1b69f0a6d6',
    'scheduled': '2021-09-23 18:55:00',
    'estimated': '2021-09-23 18:55:00',
    'claim': null,
    'checkIn': null,
    'status': 'InAir',
    'flightType': 'ARRIVAL',
    'overrides': {
      'estimated': null,
      'gate': null,
      'claim': null,
      'checkIn': null,
      'status': null,
      'languages': null,
      'remarks': null
    },
    'codeshares': [
      {
        'airlineCode': 'AM',
        'airlineCodeType': 'Iata',
        'airline': 'AeroMexico',
        'flightNumber': '4595'
      },
      {
        'airlineCode': 'KE',
        'airlineCodeType': 'Iata',
        'airline': 'Korean Air',
        'flightNumber': '7594'
      },
      {
        'airlineCode': 'KL',
        'airlineCodeType': 'Iata',
        'airline': 'KLM Royal Dutch Airlines',
        'flightNumber': '6863'
      }
    ],
    'flightNumber': '620',
    'airlineCode': 'DL',
    'airlineCodeType': 'IATA',
    'airline': 'DELTA AIR LINES',
    'state': 'MX',
    'city': 'CANCUN',
    'cityCode': 'CUN',
    'gate': 'C10'
  },
  {
    'id': '0E9285E14DB24145B757734AACB2721E',
    'scheduled': '2021-09-23 18:58:00',
    'estimated': '2021-09-23 18:58:00',
    'claim': null,
    'checkIn': null,
    'status': 'Proposed',
    'flightType': 'ARRIVAL',
    'overrides': {
      'estimated': null,
      'gate': null,
      'claim': null,
      'checkIn': null,
      'status': null,
      'languages': null,
      'remarks': null
    },
    'codeshares': [],
    'flightNumber': '555',
    'airlineCode': '5Y',
    'airlineCodeType': 'IATA',
    'airline': 'ATLAS AIR',
    'state': 'MD',
    'city': 'BALTIMORE',
    'cityCode': 'BWI',
    'gate': null
  },
  {
    'id': '7f7d85364c434388a6bb0c09881001e4',
    'scheduled': '2021-09-23 18:59:00',
    'estimated': '2021-09-23 18:59:00',
    'claim': '5',
    'checkIn': null,
    'status': 'OutGate',
    'flightType': 'ARRIVAL',
    'overrides': {
      'estimated': null,
      'gate': null,
      'claim': null,
      'checkIn': null,
      'status': null,
      'languages': null,
      'remarks': null
    },
    'codeshares': [
      {
        'airlineCode': 'AA',
        'airlineCodeType': 'Iata',
        'airline': 'American Airlines',
        'flightNumber': '9463'
      },
      {
        'airlineCode': 'EK',
        'airlineCodeType': 'Iata',
        'airline': 'Emirates Airline',
        'flightNumber': '6746'
      },
      {
        'airlineCode': 'EY',
        'airlineCodeType': 'Iata',
        'airline': 'Etihad Airways',
        'flightNumber': '8278'
      },
      {
        'airlineCode': 'QR',
        'airlineCodeType': 'Iata',
        'airline': 'Qatar Airways',
        'flightNumber': '4050'
      },
      {
        'airlineCode': 'SQ',
        'airlineCodeType': 'Iata',
        'airline': 'Singapore Airlines',
        'flightNumber': '1480'
      }
    ],
    'flightNumber': '2884',
    'airlineCode': 'B6',
    'airlineCodeType': 'IATA',
    'airline': 'JETBLUE AIRWAYS',
    'state': 'FL',
    'city': 'ORLANDO',
    'cityCode': 'MCO',
    'gate': '3'
  },
  {
    'id': '9e39490aa5164eacabf9c2baa487b909',
    'scheduled': '2021-09-23 19:00:00',
    'estimated': '2021-09-23 19:00:00',
    'claim': null,
    'checkIn': null,
    'status': 'InAir',
    'flightType': 'ARRIVAL',
    'overrides': {
      'estimated': null,
      'gate': null,
      'claim': null,
      'checkIn': null,
      'status': null,
      'languages': null,
      'remarks': null
    },
    'codeshares': [
      {
        'airlineCode': 'B6',
        'airlineCodeType': 'Iata',
        'airline': 'JetBlue Airways',
        'flightNumber': '5011'
      }
    ],
    'flightNumber': '205',
    'airlineCode': 'EK',
    'airlineCodeType': 'IATA',
    'airline': 'EMIRATES AIRLINE',
    'state': 'IT',
    'city': 'MILANO',
    'cityCode': 'MXP',
    'gate': 'B'
  },
  {
    'id': 'ef89320bfe3d41e9961ba05ae905199f',
    'scheduled': '2021-09-23 19:00:00',
    'estimated': '2021-09-23 19:00:00',
    'claim': '3',
    'checkIn': null,
    'status': 'InAir',
    'flightType': 'ARRIVAL',
    'overrides': {
      'estimated': null,
      'gate': null,
      'claim': null,
      'checkIn': null,
      'status': null,
      'languages': null,
      'remarks': null
    },
    'codeshares': [
      {
        'airlineCode': 'EK',
        'airlineCodeType': 'Iata',
        'airline': 'Emirates Airline',
        'flightNumber': '6874'
      },
      {
        'airlineCode': 'EY',
        'airlineCodeType': 'Iata',
        'airline': 'Etihad Airways',
        'flightNumber': '8312'
      },
      {
        'airlineCode': 'HA',
        'airlineCodeType': 'Iata',
        'airline': 'Hawaiian Airlines',
        'flightNumber': '2310'
      },
      {
        'airlineCode': 'QR',
        'airlineCodeType': 'Iata',
        'airline': 'Qatar Airways',
        'flightNumber': '3982'
      },
      {
        'airlineCode': 'SQ',
        'airlineCodeType': 'Iata',
        'airline': 'Singapore Airlines',
        'flightNumber': '1530'
      }
    ],
    'flightNumber': '324',
    'airlineCode': 'B6',
    'airlineCodeType': 'IATA',
    'airline': 'JETBLUE AIRWAYS',
    'state': 'CA',
    'city': 'LOS ANGELES',
    'cityCode': 'LAX',
    'gate': '59'
  },
  {
    'id': 'd66ec06e57954951aa16d3f67287f53b',
    'scheduled': '2021-09-23 19:01:00',
    'estimated': '2021-09-23 19:01:00',
    'claim': '1',
    'checkIn': null,
    'status': 'Delayed',
    'flightType': 'ARRIVAL',
    'overrides': {
      'estimated': null,
      'gate': null,
      'claim': null,
      'checkIn': null,
      'status': null,
      'languages': null,
      'remarks': null
    },
    'codeshares': [
      {
        'airlineCode': 'AA',
        'airlineCodeType': 'Iata',
        'airline': 'American Airlines',
        'flightNumber': '9340'
      },
      {
        'airlineCode': 'EK',
        'airlineCodeType': 'Iata',
        'airline': 'Emirates Airline',
        'flightNumber': '6894'
      },
      {
        'airlineCode': 'EY',
        'airlineCodeType': 'Iata',
        'airline': 'Etihad Airways',
        'flightNumber': '8244'
      },
      {
        'airlineCode': 'LY',
        'airlineCodeType': 'Iata',
        'airline': 'El Al Israel Airlines',
        'flightNumber': '8628'
      },
      {
        'airlineCode': 'QR',
        'airlineCodeType': 'Iata',
        'airline': 'Qatar Airways',
        'flightNumber': '4076'
      },
      {
        'airlineCode': 'TK',
        'airlineCodeType': 'Iata',
        'airline': 'Turkish Airlines',
        'flightNumber': '8960'
      }
    ],
    'flightNumber': '1274',
    'airlineCode': 'B6',
    'airlineCodeType': 'IATA',
    'airline': 'JETBLUE AIRWAYS',
    'state': 'SC',
    'city': 'CHARLESTON',
    'cityCode': 'CHS',
    'gate': 'B8'
  },
  {
    'id': 'f6db7260001e4df39cc8f11396885f4f',
    'scheduled': '2021-09-23 19:03:00',
    'estimated': '2021-09-23 19:03:00',
    'claim': null,
    'checkIn': null,
    'status': 'Delayed',
    'flightType': 'ARRIVAL',
    'overrides': {
      'estimated': null,
      'gate': null,
      'claim': null,
      'checkIn': null,
      'status': null,
      'languages': null,
      'remarks': null
    },
    'codeshares': [
      {
        'airlineCode': 'AZ',
        'airlineCodeType': 'Iata',
        'airline': 'Alitalia',
        'flightNumber': '3396'
      },
      {
        'airlineCode': 'VS',
        'airlineCodeType': 'Iata',
        'airline': 'Virgin Atlantic',
        'flightNumber': '3581'
      },
      {
        'airlineCode': 'WS',
        'airlineCodeType': 'Iata',
        'airline': 'WestJet Airlines',
        'flightNumber': '6556'
      }
    ],
    'flightNumber': '4736',
    'airlineCode': 'DL',
    'airlineCodeType': 'IATA',
    'airline': 'DELTA AIR LINES',
    'state': 'SC',
    'city': 'CHARLESTON',
    'cityCode': 'CHS',
    'gate': 'A5'
  },
  {
    'id': '20f2d60d7e1b4c6597e5f9b169e647f8',
    'scheduled': '2021-09-23 12:12:00',
    'estimated': '2021-09-23 12:12:00',
    'claim': '7',
    'checkIn': null,
    'status': 'Landed',
    'flightType': 'ARRIVAL',
    'overrides': {
      'estimated': null,
      'gate': null,
      'claim': null,
      'checkIn': null,
      'status': null,
      'languages': null,
      'remarks': null
    },
    'codeshares': [
      {
        'airlineCode': 'B6',
        'airlineCodeType': 'Iata',
        'airline': 'JetBlue Airways',
        'flightNumber': '4120'
      },
      {
        'airlineCode': 'G3',
        'airlineCodeType': 'Iata',
        'airline': 'GOL Transportes Aereos',
        'flightNumber': '6275'
      },
      {
        'airlineCode': 'IB',
        'airlineCodeType': 'Iata',
        'airline': 'Iberia Airlines',
        'flightNumber': '4434'
      },
      {
        'airlineCode': 'MH',
        'airlineCodeType': 'Iata',
        'airline': 'Malaysia Airlines',
        'flightNumber': '9341'
      }
    ],
    'flightNumber': '688',
    'airlineCode': 'AA',
    'airlineCodeType': 'IATA',
    'airline': 'AMERICAN AIRLINES',
    'state': 'FL',
    'city': 'MIAMI',
    'cityCode': 'MIA',
    'gate': 'D27'
  },
  {
    'id': 'ED61E0B51CD5479D80DC8E4A027039C5',
    'scheduled': '2021-09-23 12:12:00',
    'estimated': '2021-09-23 12:12:00',
    'claim': '7',
    'checkIn': null,
    'status': 'Delayed',
    'flightType': 'ARRIVAL',
    'overrides': {
      'estimated': null,
      'gate': null,
      'claim': null,
      'checkIn': null,
      'status': null,
      'languages': null,
      'remarks': null
    },
    'codeshares': [
      {
        'airlineCode': 'B6',
        'airlineCodeType': 'Iata',
        'airline': 'JetBlue Airways',
        'flightNumber': '4120'
      },
      {
        'airlineCode': 'MH',
        'airlineCodeType': 'Iata',
        'airline': 'Malaysia Airlines',
        'flightNumber': '9341'
      },
      {
        'airlineCode': 'IB',
        'airlineCodeType': 'Iata',
        'airline': 'Iberia Airlines',
        'flightNumber': '4434'
      },
      {
        'airlineCode': 'G3',
        'airlineCodeType': 'Iata',
        'airline': 'GOL Transportes Aereos',
        'flightNumber': '6275'
      }
    ],
    'flightNumber': '688',
    'airlineCode': 'AA',
    'airlineCodeType': 'IATA',
    'airline': 'AMERICAN AIRLINES',
    'state': 'FL',
    'city': 'MIAMI',
    'cityCode': 'MIA',
    'gate': 'CG6'
  },
  {
    'id': '2d4f5020c9b44e40961769b6992ee0ab',
    'scheduled': '2021-09-23 19:05:00',
    'estimated': '2021-09-23 19:05:00',
    'claim': null,
    'checkIn': null,
    'status': 'InAir',
    'flightType': 'ARRIVAL',
    'overrides': {
      'estimated': null,
      'gate': null,
      'claim': null,
      'checkIn': null,
      'status': null,
      'languages': null,
      'remarks': null
    },
    'codeshares': [
      {
        'airlineCode': 'AA',
        'airlineCodeType': 'Iata',
        'airline': 'American Airlines',
        'flightNumber': '8985'
      },
      {
        'airlineCode': 'BA',
        'airlineCodeType': 'Iata',
        'airline': 'British Airways',
        'flightNumber': '6051'
      },
      {
        'airlineCode': 'IB',
        'airlineCodeType': 'Iata',
        'airline': 'Iberia Airlines',
        'flightNumber': '367'
      }
    ],
    'flightNumber': '15',
    'airlineCode': 'AY',
    'airlineCodeType': 'IATA',
    'airline': 'FINNAIR',
    'state': 'FI',
    'city': 'HELSINKI',
    'cityCode': 'HEL',
    'gate': '45A'
  },
  {
    'id': 'f39ff3fef9d042ceaf1abcfa4a7df420',
    'scheduled': '2021-09-23 19:09:00',
    'estimated': '2021-09-23 19:09:00',
    'claim': null,
    'checkIn': null,
    'status': 'Delayed',
    'flightType': 'ARRIVAL',
    'overrides': {
      'estimated': null,
      'gate': null,
      'claim': null,
      'checkIn': null,
      'status': null,
      'languages': null,
      'remarks': null
    },
    'codeshares': [
      {
        'airlineCode': 'KL',
        'airlineCodeType': 'Iata',
        'airline': 'KLM Royal Dutch Airlines',
        'flightNumber': '8224'
      },
      {
        'airlineCode': 'AF',
        'airlineCodeType': 'Iata',
        'airline': 'Air France',
        'flightNumber': '2584'
      },
      {
        'airlineCode': 'AZ',
        'airlineCodeType': 'Iata',
        'airline': 'Alitalia',
        'flightNumber': '3157'
      },
      {
        'airlineCode': 'VS',
        'airlineCodeType': 'Iata',
        'airline': 'Virgin Atlantic',
        'flightNumber': '4696'
      }
    ],
    'flightNumber': '4865',
    'airlineCode': 'DL',
    'airlineCodeType': 'IATA',
    'airline': 'DELTA AIR LINES',
    'state': 'NY',
    'city': 'ROCHESTER',
    'cityCode': 'ROC',
    'gate': 'B5'
  },
  {
    'id': 'fc7dd2c2c3b1486db9e1b441e0e8f80f',
    'scheduled': '2021-09-23 19:10:00',
    'estimated': '2021-09-23 19:10:00',
    'claim': '7',
    'checkIn': null,
    'status': 'InAir',
    'flightType': 'ARRIVAL',
    'overrides': {
      'estimated': null,
      'gate': null,
      'claim': null,
      'checkIn': null,
      'status': null,
      'languages': null,
      'remarks': null
    },
    'codeshares': [
      {
        'airlineCode': 'EK',
        'airlineCodeType': 'Iata',
        'airline': 'Emirates Airline',
        'flightNumber': '6868'
      }
    ],
    'flightNumber': '380',
    'airlineCode': 'B6',
    'airlineCodeType': 'IATA',
    'airline': 'JETBLUE AIRWAYS',
    'state': 'JM',
    'city': 'MONTEGO BAY',
    'cityCode': 'MBJ',
    'gate': '4'
  },
  {
    'id': '06f95df97ba0413ca8e99cbbe3753d93',
    'scheduled': '2021-09-23 19:10:00',
    'estimated': '2021-09-23 19:10:00',
    'claim': '1',
    'checkIn': null,
    'status': 'Delayed',
    'flightType': 'ARRIVAL',
    'overrides': {
      'estimated': null,
      'gate': null,
      'claim': null,
      'checkIn': null,
      'status': null,
      'languages': null,
      'remarks': null
    },
    'codeshares': [
      {
        'airlineCode': 'EK',
        'airlineCodeType': 'Iata',
        'airline': 'Emirates Airline',
        'flightNumber': '6444'
      },
      {
        'airlineCode': 'QR',
        'airlineCodeType': 'Iata',
        'airline': 'Qatar Airways',
        'flightNumber': '3859'
      }
    ],
    'flightNumber': '2092',
    'airlineCode': 'B6',
    'airlineCodeType': 'IATA',
    'airline': 'JETBLUE AIRWAYS',
    'state': 'FL',
    'city': 'MIAMI',
    'cityCode': 'MIA',
    'gate': 'E20'
  },
  {
    'id': '44d7249ad75d43eeacafd9ced0a17e7d',
    'scheduled': '2021-09-23 19:10:00',
    'estimated': '2021-09-23 19:10:00',
    'claim': null,
    'checkIn': null,
    'status': 'InAir',
    'flightType': 'ARRIVAL',
    'overrides': {
      'estimated': null,
      'gate': null,
      'claim': null,
      'checkIn': null,
      'status': null,
      'languages': null,
      'remarks': null
    },
    'codeshares': [
      {
        'airlineCode': 'B6',
        'airlineCodeType': 'Iata',
        'airline': 'JetBlue Airways',
        'flightNumber': '5615'
      },
      {
        'airlineCode': 'BT',
        'airlineCodeType': 'Iata',
        'airline': 'Air Baltic Corp',
        'flightNumber': '6284'
      }
    ],
    'flightNumber': '615',
    'airlineCode': 'FI',
    'airlineCodeType': 'IATA',
    'airline': 'ICELANDAIR',
    'state': 'IS',
    'city': 'REYKJAVIK',
    'cityCode': 'KEF',
    'gate': 'D29'
  },
  {
    'id': '5aabc294fbd24e6893da20d0576ae2ac',
    'scheduled': '2021-09-23 19:15:00',
    'estimated': '2021-09-23 19:15:00',
    'claim': null,
    'checkIn': null,
    'status': 'Delayed',
    'flightType': 'ARRIVAL',
    'overrides': {
      'estimated': null,
      'gate': null,
      'claim': null,
      'checkIn': null,
      'status': null,
      'languages': null,
      'remarks': null
    },
    'codeshares': [
      {
        'airlineCode': 'AZ',
        'airlineCodeType': 'Iata',
        'airline': 'Alitalia',
        'flightNumber': '5976'
      },
      {
        'airlineCode': 'KL',
        'airlineCodeType': 'Iata',
        'airline': 'KLM Royal Dutch Airlines',
        'flightNumber': '7066'
      },
      {
        'airlineCode': 'VS',
        'airlineCodeType': 'Iata',
        'airline': 'Virgin Atlantic',
        'flightNumber': '4902'
      }
    ],
    'flightNumber': '4637',
    'airlineCode': 'DL',
    'airlineCodeType': 'IATA',
    'airline': 'DELTA AIR LINES',
    'state': 'MN',
    'city': 'MINNEAPOLIS',
    'cityCode': 'MSP',
    'gate': 'C21'
  },
  {
    'id': '5B7238A0C40C4604BE0459DAF53FF41F',
    'scheduled': '2021-09-23 19:16:00',
    'estimated': '2021-09-23 19:16:00',
    'claim': null,
    'checkIn': null,
    'status': 'NoTakeoffInfo',
    'flightType': 'ARRIVAL',
    'overrides': {
      'estimated': null,
      'gate': null,
      'claim': null,
      'checkIn': null,
      'status': null,
      'languages': null,
      'remarks': null
    },
    'codeshares': [],
    'flightNumber': '558',
    'airlineCode': 'FX',
    'airlineCodeType': 'IATA',
    'airline': 'FEDEX AIR',
    'state': 'TN',
    'city': 'MEMPHIS',
    'cityCode': 'MEM',
    'gate': null
  },
  {
    'id': '3b767b8941b64317b2e53b898630ab76',
    'scheduled': '2021-09-23 19:20:00',
    'estimated': '2021-09-23 19:20:00',
    'claim': '7',
    'checkIn': null,
    'status': 'InAir',
    'flightType': 'ARRIVAL',
    'overrides': {
      'estimated': null,
      'gate': null,
      'claim': null,
      'checkIn': null,
      'status': null,
      'languages': null,
      'remarks': null
    },
    'codeshares': [
      {
        'airlineCode': 'EK',
        'airlineCodeType': 'Iata',
        'airline': 'Emirates Airline',
        'flightNumber': '6838'
      }
    ],
    'flightNumber': '852',
    'airlineCode': 'B6',
    'airlineCodeType': 'IATA',
    'airline': 'JETBLUE AIRWAYS',
    'state': 'MX',
    'city': 'CANCUN',
    'cityCode': 'CUN',
    'gate': '56'
  },
  {
    'id': '54ab2d7b7ac04f65a170afb304e0ab04',
    'scheduled': '2021-09-23 19:20:00',
    'estimated': '2021-09-23 19:20:00',
    'claim': null,
    'checkIn': null,
    'status': 'InAir',
    'flightType': 'ARRIVAL',
    'overrides': {
      'estimated': null,
      'gate': null,
      'claim': null,
      'checkIn': null,
      'status': null,
      'languages': null,
      'remarks': null
    },
    'codeshares': [
      {
        'airlineCode': 'AM',
        'airlineCodeType': 'Iata',
        'airline': 'AeroMexico',
        'flightNumber': '7871'
      },
      {
        'airlineCode': 'AR',
        'airlineCodeType': 'Iata',
        'airline': 'Aerolineas Argentinas',
        'flightNumber': '7855'
      }
    ],
    'flightNumber': '7',
    'airlineCode': 'LY',
    'airlineCodeType': 'IATA',
    'airline': 'EL AL ISRAEL AIRLINES',
    'state': 'IL',
    'city': 'TEL AVIV',
    'cityCode': 'TLV',
    'gate': null
  },
  {
    'id': '77fc02a3cc2c4f5dbe4402c2dc1288e7',
    'scheduled': '2021-09-23 19:25:00',
    'estimated': '2021-09-23 19:25:00',
    'claim': null,
    'checkIn': null,
    'status': 'InAir',
    'flightType': 'ARRIVAL',
    'overrides': {
      'estimated': null,
      'gate': null,
      'claim': null,
      'checkIn': null,
      'status': null,
      'languages': null,
      'remarks': null
    },
    'codeshares': [
      {
        'airlineCode': 'AA',
        'airlineCodeType': 'Iata',
        'airline': 'American Airlines',
        'flightNumber': '8645'
      },
      {
        'airlineCode': 'AY',
        'airlineCodeType': 'Iata',
        'airline': 'Finnair',
        'flightNumber': '5653'
      },
      {
        'airlineCode': 'BA',
        'airlineCodeType': 'Iata',
        'airline': 'British Airways',
        'flightNumber': '4267'
      }
    ],
    'flightNumber': '6251',
    'airlineCode': 'IB',
    'airlineCodeType': 'IATA',
    'airline': 'IBERIA AIRLINES',
    'state': 'ES',
    'city': 'MADRID',
    'cityCode': 'MAD',
    'gate': null
  },
  {
    'id': 'fe0e5c4035264882a83a950f71163e30',
    'scheduled': '2021-09-23 19:27:00',
    'estimated': '2021-09-23 19:27:00',
    'claim': '7',
    'checkIn': null,
    'status': 'Delayed',
    'flightType': 'ARRIVAL',
    'overrides': {
      'estimated': null,
      'gate': null,
      'claim': null,
      'checkIn': null,
      'status': null,
      'languages': null,
      'remarks': null
    },
    'codeshares': [
      {
        'airlineCode': 'B6',
        'airlineCodeType': 'Iata',
        'airline': 'JetBlue Airways',
        'flightNumber': '4157'
      },
      {
        'airlineCode': 'BA',
        'airlineCodeType': 'Iata',
        'airline': 'British Airways',
        'flightNumber': '4357'
      },
      {
        'airlineCode': 'IB',
        'airlineCodeType': 'Iata',
        'airline': 'Iberia Airlines',
        'flightNumber': '4913'
      },
      {
        'airlineCode': 'MH',
        'airlineCodeType': 'Iata',
        'airline': 'Malaysia Airlines',
        'flightNumber': '9458'
      },
      {
        'airlineCode': 'QR',
        'airlineCodeType': 'Iata',
        'airline': 'Qatar Airways',
        'flightNumber': '7844'
      },
      {
        'airlineCode': 'RJ',
        'airlineCodeType': 'Iata',
        'airline': 'Royal Jordanian',
        'flightNumber': '7148'
      }
    ],
    'flightNumber': '1199',
    'airlineCode': 'AA',
    'airlineCodeType': 'IATA',
    'airline': 'AMERICAN AIRLINES',
    'state': 'FL',
    'city': 'MIAMI',
    'cityCode': 'MIA',
    'gate': 'D33'
  },
  {
    'id': '0ac4c68f44ee4a64bbbe2df1f9766a22',
    'scheduled': '2021-09-23 13:53:00',
    'estimated': '2021-09-23 13:53:00',
    'claim': null,
    'checkIn': null,
    'status': 'InGate',
    'flightType': 'ARRIVAL',
    'overrides': {
      'estimated': null,
      'gate': null,
      'claim': null,
      'checkIn': null,
      'status': null,
      'languages': null,
      'remarks': null
    },
    'codeshares': [
      {
        'airlineCode': 'AF',
        'airlineCodeType': 'Iata',
        'airline': 'Air France',
        'flightNumber': '2610'
      },
      {
        'airlineCode': 'KL',
        'airlineCodeType': 'Iata',
        'airline': 'KLM Royal Dutch Airlines',
        'flightNumber': '5138'
      },
      {
        'airlineCode': 'SU',
        'airlineCodeType': 'Iata',
        'airline': 'Aeroflot Airlines',
        'flightNumber': '3523'
      },
      {
        'airlineCode': 'VS',
        'airlineCodeType': 'Iata',
        'airline': 'Virgin Atlantic',
        'flightNumber': '4784'
      }
    ],
    'flightNumber': '1267',
    'airlineCode': 'DL',
    'airlineCodeType': 'IATA',
    'airline': 'DELTA AIR LINES',
    'state': 'FL',
    'city': 'TAMPA',
    'cityCode': 'TPA',
    'gate': 'E67'
  },
  {
    'id': '07EF67E706234082A76C7E20300B3C77',
    'scheduled': '2021-09-23 13:53:00',
    'estimated': '2021-09-23 13:53:00',
    'claim': null,
    'checkIn': null,
    'status': 'Delayed',
    'flightType': 'ARRIVAL',
    'overrides': {
      'estimated': null,
      'gate': null,
      'claim': null,
      'checkIn': null,
      'status': null,
      'languages': null,
      'remarks': null
    },
    'codeshares': [
      {
        'airlineCode': 'SU',
        'airlineCodeType': 'Iata',
        'airline': 'Aeroflot Airlines',
        'flightNumber': '3523'
      },
      {
        'airlineCode': 'AF',
        'airlineCodeType': 'Iata',
        'airline': 'Air France',
        'flightNumber': '2610'
      },
      {
        'airlineCode': 'KL',
        'airlineCodeType': 'Iata',
        'airline': 'KLM Royal Dutch Airlines',
        'flightNumber': '5138'
      },
      {
        'airlineCode': 'VS',
        'airlineCodeType': 'Iata',
        'airline': 'Virgin Atlantic',
        'flightNumber': '4784'
      }
    ],
    'flightNumber': '1267',
    'airlineCode': 'DL',
    'airlineCodeType': 'IATA',
    'airline': 'DELTA AIR LINES',
    'state': 'FL',
    'city': 'TAMPA',
    'cityCode': 'TPA',
    'gate': 'A76'
  },
  {
    'id': 'a36b1125eb7f41dab48c5633c201eb70',
    'scheduled': '2021-09-23 17:25:00',
    'estimated': '2021-09-23 17:25:00',
    'claim': null,
    'checkIn': null,
    'status': 'Landed',
    'flightType': 'ARRIVAL',
    'overrides': {
      'estimated': null,
      'gate': null,
      'claim': null,
      'checkIn': null,
      'status': null,
      'languages': null,
      'remarks': null
    },
    'codeshares': [
      {
        'airlineCode': 'AF',
        'airlineCodeType': 'Iata',
        'airline': 'Air France',
        'flightNumber': '2558'
      },
      {
        'airlineCode': 'AZ',
        'airlineCodeType': 'Iata',
        'airline': 'Alitalia',
        'flightNumber': '3376'
      },
      {
        'airlineCode': 'KL',
        'airlineCodeType': 'Iata',
        'airline': 'KLM Royal Dutch Airlines',
        'flightNumber': '5318'
      },
      {
        'airlineCode': 'SU',
        'airlineCodeType': 'Iata',
        'airline': 'Aeroflot Airlines',
        'flightNumber': '3539'
      },
      {
        'airlineCode': 'UX',
        'airlineCodeType': 'Iata',
        'airline': 'Air Europa',
        'flightNumber': '3413'
      },
      {
        'airlineCode': 'VS',
        'airlineCodeType': 'Iata',
        'airline': 'Virgin Atlantic',
        'flightNumber': '4812'
      }
    ],
    'flightNumber': '875',
    'airlineCode': 'DL',
    'airlineCodeType': 'IATA',
    'airline': 'DELTA AIR LINES',
    'state': 'CO',
    'city': 'DENVER',
    'cityCode': 'DEN',
    'gate': 'A31'
  },
  {
    'id': '4B404008C1AE4EB68D925FB448B59284',
    'scheduled': '2021-09-23 17:25:00',
    'estimated': '2021-09-23 17:25:00',
    'claim': null,
    'checkIn': null,
    'status': 'Delayed',
    'flightType': 'ARRIVAL',
    'overrides': {
      'estimated': null,
      'gate': null,
      'claim': null,
      'checkIn': null,
      'status': null,
      'languages': null,
      'remarks': null
    },
    'codeshares': [
      {
        'airlineCode': 'AZ',
        'airlineCodeType': 'Iata',
        'airline': 'Alitalia',
        'flightNumber': '3376'
      },
      {
        'airlineCode': 'AF',
        'airlineCodeType': 'Iata',
        'airline': 'Air France',
        'flightNumber': '2558'
      },
      {
        'airlineCode': 'KL',
        'airlineCodeType': 'Iata',
        'airline': 'KLM Royal Dutch Airlines',
        'flightNumber': '5318'
      },
      {
        'airlineCode': 'SU',
        'airlineCodeType': 'Iata',
        'airline': 'Aeroflot Airlines',
        'flightNumber': '3539'
      },
      {
        'airlineCode': 'UX',
        'airlineCodeType': 'Iata',
        'airline': 'Air Europa',
        'flightNumber': '3413'
      },
      {
        'airlineCode': 'VS',
        'airlineCodeType': 'Iata',
        'airline': 'Virgin Atlantic',
        'flightNumber': '4812'
      }
    ],
    'flightNumber': '875',
    'airlineCode': 'DL',
    'airlineCodeType': 'IATA',
    'airline': 'DELTA AIR LINES',
    'state': 'CO',
    'city': 'DENVER',
    'cityCode': 'DEN',
    'gate': 'B76'
  },
  {
    'id': 'a28ad02298e34c3899878c376c0dbb12',
    'scheduled': '2021-09-23 19:32:00',
    'estimated': '2021-09-23 19:32:00',
    'claim': null,
    'checkIn': null,
    'status': 'Scheduled',
    'flightType': 'ARRIVAL',
    'overrides': {
      'estimated': null,
      'gate': null,
      'claim': null,
      'checkIn': null,
      'status': null,
      'languages': null,
      'remarks': null
    },
    'codeshares': [
      {
        'airlineCode': 'AF',
        'airlineCodeType': 'Iata',
        'airline': 'Air France',
        'flightNumber': '2638'
      },
      {
        'airlineCode': 'AZ',
        'airlineCodeType': 'Iata',
        'airline': 'Alitalia',
        'flightNumber': '3147'
      },
      {
        'airlineCode': 'KL',
        'airlineCodeType': 'Iata',
        'airline': 'KLM Royal Dutch Airlines',
        'flightNumber': '6415'
      },
      {
        'airlineCode': 'VS',
        'airlineCodeType': 'Iata',
        'airline': 'Virgin Atlantic',
        'flightNumber': '4494'
      },
      {
        'airlineCode': 'WS',
        'airlineCodeType': 'Iata',
        'airline': 'WestJet Airlines',
        'flightNumber': '6525'
      }
    ],
    'flightNumber': '4891',
    'airlineCode': 'DL',
    'airlineCodeType': 'IATA',
    'airline': 'DELTA AIR LINES',
    'state': 'NY',
    'city': 'BUFFALO',
    'cityCode': 'BUF',
    'gate': '22'
  },
  {
    'id': '272A3783352D4A2BA8520761851AA8F3',
    'scheduled': '2021-09-23 19:43:00',
    'estimated': '2021-09-23 19:43:00',
    'claim': null,
    'checkIn': null,
    'status': 'Proposed',
    'flightType': 'ARRIVAL',
    'overrides': {
      'estimated': null,
      'gate': null,
      'claim': null,
      'checkIn': null,
      'status': null,
      'languages': null,
      'remarks': null
    },
    'codeshares': [],
    'flightNumber': '764',
    'airlineCode': 'FX',
    'airlineCodeType': 'IATA',
    'airline': 'FEDEX AIR',
    'state': 'TN',
    'city': 'MEMPHIS',
    'cityCode': 'MEM',
    'gate': null
  },
  {
    'id': '1748a37d5e044a129bd97bd88f15fe1e',
    'scheduled': '2021-09-23 19:43:00',
    'estimated': '2021-09-23 19:43:00',
    'claim': '2',
    'checkIn': null,
    'status': 'InAir',
    'flightType': 'ARRIVAL',
    'overrides': {
      'estimated': null,
      'gate': null,
      'claim': null,
      'checkIn': null,
      'status': null,
      'languages': null,
      'remarks': null
    },
    'codeshares': [
      {
        'airlineCode': 'AA',
        'airlineCodeType': 'Iata',
        'airline': 'American Airlines',
        'flightNumber': '9267'
      },
      {
        'airlineCode': 'EK',
        'airlineCodeType': 'Iata',
        'airline': 'Emirates Airline',
        'flightNumber': '6134'
      },
      {
        'airlineCode': 'HA',
        'airlineCodeType': 'Iata',
        'airline': 'Hawaiian Airlines',
        'flightNumber': '2324'
      },
      {
        'airlineCode': 'QR',
        'airlineCodeType': 'Iata',
        'airline': 'Qatar Airways',
        'flightNumber': '3970'
      },
      {
        'airlineCode': 'AT',
        'airlineCodeType': 'Iata',
        'airline': 'Royal Air Maroc',
        'flightNumber': '9641'
      }
    ],
    'flightNumber': '748',
    'airlineCode': 'B6',
    'airlineCodeType': 'IATA',
    'airline': 'JETBLUE AIRWAYS',
    'state': 'NV',
    'city': 'LAS VEGAS',
    'cityCode': 'LAS',
    'gate': 'D3'
  },
  {
    'id': '4d3161a80b5047349086d46eda7fc090',
    'scheduled': '2021-09-23 19:44:00',
    'estimated': '2021-09-23 19:44:00',
    'claim': null,
    'checkIn': null,
    'status': 'InAir',
    'flightType': 'ARRIVAL',
    'overrides': {
      'estimated': null,
      'gate': null,
      'claim': null,
      'checkIn': null,
      'status': null,
      'languages': null,
      'remarks': null
    },
    'codeshares': [
      {
        'airlineCode': 'AF',
        'airlineCodeType': 'Iata',
        'airline': 'Air France',
        'flightNumber': '2493'
      },
      {
        'airlineCode': 'AZ',
        'airlineCodeType': 'Iata',
        'airline': 'Alitalia',
        'flightNumber': '5897'
      },
      {
        'airlineCode': 'KL',
        'airlineCodeType': 'Iata',
        'airline': 'KLM Royal Dutch Airlines',
        'flightNumber': '5065'
      },
      {
        'airlineCode': 'LA',
        'airlineCodeType': 'Iata',
        'airline': 'LATAM Airlines Group',
        'flightNumber': '6258'
      },
      {
        'airlineCode': 'UX',
        'airlineCodeType': 'Iata',
        'airline': 'Air Europa',
        'flightNumber': '3341'
      },
      {
        'airlineCode': 'VS',
        'airlineCodeType': 'Iata',
        'airline': 'Virgin Atlantic',
        'flightNumber': '4852'
      }
    ],
    'flightNumber': '562',
    'airlineCode': 'DL',
    'airlineCodeType': 'IATA',
    'airline': 'DELTA AIR LINES',
    'state': 'CA',
    'city': 'LOS ANGELES',
    'cityCode': 'LAX',
    'gate': '21'
  },
  {
    'id': 'abf38db15a8843ebb362b4e9365e2c8e',
    'scheduled': '2021-09-23 19:50:00',
    'estimated': '2021-09-23 19:50:00',
    'claim': null,
    'checkIn': null,
    'status': 'InAir',
    'flightType': 'ARRIVAL',
    'overrides': {
      'estimated': null,
      'gate': null,
      'claim': null,
      'checkIn': null,
      'status': null,
      'languages': null,
      'remarks': null
    },
    'codeshares': [],
    'flightNumber': '3298',
    'airlineCode': 'CX',
    'airlineCodeType': 'IATA',
    'airline': 'CATHAY PACIFIC',
    'state': 'AK',
    'city': 'ANCHORAGE',
    'cityCode': 'ANC',
    'gate': null
  },
  {
    'id': '9507375e2d9c490b99c1008f9c905218',
    'scheduled': '2021-09-23 19:58:00',
    'estimated': '2021-09-23 19:58:00',
    'claim': '4',
    'checkIn': null,
    'status': 'InAir',
    'flightType': 'ARRIVAL',
    'overrides': {
      'estimated': null,
      'gate': null,
      'claim': null,
      'checkIn': null,
      'status': null,
      'languages': null,
      'remarks': null
    },
    'codeshares': [
      {
        'airlineCode': 'AA',
        'airlineCodeType': 'Iata',
        'airline': 'American Airlines',
        'flightNumber': '9367'
      },
      {
        'airlineCode': 'EK',
        'airlineCodeType': 'Iata',
        'airline': 'Emirates Airline',
        'flightNumber': '6784'
      },
      {
        'airlineCode': 'LY',
        'airlineCodeType': 'Iata',
        'airline': 'El Al Israel Airlines',
        'flightNumber': '8634'
      },
      {
        'airlineCode': 'QR',
        'airlineCodeType': 'Iata',
        'airline': 'Qatar Airways',
        'flightNumber': '4016'
      },
      {
        'airlineCode': 'SQ',
        'airlineCodeType': 'Iata',
        'airline': 'Singapore Airlines',
        'flightNumber': '1506'
      }
    ],
    'flightNumber': '1498',
    'airlineCode': 'B6',
    'airlineCodeType': 'IATA',
    'airline': 'JETBLUE AIRWAYS',
    'state': 'CO',
    'city': 'DENVER',
    'cityCode': 'DEN',
    'gate': 'A39'
  }
];